import { render, staticRenderFns } from "./DashboardCompany.vue?vue&type=template&id=13a7abac&scoped=true"
import script from "./DashboardCompany.vue?vue&type=script&lang=js"
export * from "./DashboardCompany.vue?vue&type=script&lang=js"
import style0 from "./DashboardCompany.vue?vue&type=style&index=0&id=13a7abac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a7abac",
  null
  
)

export default component.exports